import script from "./CounterpartiesExpandModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CounterpartiesExpandModal.vue?vue&type=script&setup=true&lang=ts"

import "./CounterpartiesExpandModal.vue?vue&type=style&index=0&id=79acbfa0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79acbfa0"]])

export default __exports__